module.exports = __webpack_public_path__ + "static/media/elsa-jean.b1d01422.jpg";